module.exports = __webpack_public_path__ + "img/Flaherty.4e904e45.jpg";